"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _cssinjs = require("@ant-design/cssinjs");
var _multiple = require("../../select/style/multiple");
var _internal = require("../../theme/internal");
var genSize = function genSize(token, suffix) {
  var componentCls = token.componentCls,
    controlHeight = token.controlHeight;
  var suffixCls = suffix ? "".concat(componentCls, "-").concat(suffix) : '';
  var multipleSelectorUnit = (0, _multiple.getMultipleSelectorUnit)(token);
  return [// genSelectionStyle(token, suffix),
  _defineProperty({}, "".concat(componentCls, "-multiple").concat(suffixCls), _defineProperty({
    paddingBlock: multipleSelectorUnit.containerPadding,
    paddingInlineStart: multipleSelectorUnit.basePadding,
    minHeight: controlHeight
  }, "".concat(componentCls, "-selection-item"), {
    height: multipleSelectorUnit.itemHeight,
    lineHeight: (0, _cssinjs.unit)(multipleSelectorUnit.itemLineHeight)
  }))];
};
var genPickerMultipleStyle = function genPickerMultipleStyle(token) {
  var componentCls = token.componentCls,
    calc = token.calc,
    lineWidth = token.lineWidth;
  var smallToken = (0, _internal.mergeToken)(token, {
    fontHeight: token.fontSize,
    selectHeight: token.controlHeightSM,
    multipleSelectItemHeight: token.multipleItemHeightSM,
    borderRadius: token.borderRadiusSM,
    borderRadiusSM: token.borderRadiusXS,
    controlHeight: token.controlHeightSM
  });
  var largeToken = (0, _internal.mergeToken)(token, {
    fontHeight: calc(token.multipleItemHeightLG).sub(calc(lineWidth).mul(2).equal()).equal(),
    fontSize: token.fontSizeLG,
    selectHeight: token.controlHeightLG,
    multipleSelectItemHeight: token.multipleItemHeightLG,
    borderRadius: token.borderRadiusLG,
    borderRadiusSM: token.borderRadius,
    controlHeight: token.controlHeightLG
  });
  return [
  // ======================== Size ========================
  genSize(smallToken, 'small'), genSize(token), genSize(largeToken, 'large'), // ====================== Selection ======================
  _defineProperty({}, "".concat(componentCls).concat(componentCls, "-multiple"), Object.assign(Object.assign(_defineProperty({
    width: '100%',
    cursor: 'text'
  }, "".concat(componentCls, "-selector"), _defineProperty({
    flex: 'auto',
    padding: 0,
    position: 'relative',
    '&:after': {
      margin: 0
    }
  }, "".concat(componentCls, "-selection-placeholder"), {
    position: 'absolute',
    top: '50%',
    insetInlineStart: token.inputPaddingHorizontalBase,
    insetInlineEnd: 0,
    transform: 'translateY(-50%)',
    transition: "all ".concat(token.motionDurationSlow),
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    flex: 1,
    color: token.colorTextPlaceholder,
    pointerEvents: 'none'
  })), (0, _multiple.genOverflowStyle)(token)), _defineProperty({}, "".concat(componentCls, "-multiple-input"), {
    width: 0,
    height: 0,
    border: 0,
    visibility: 'hidden',
    position: 'absolute',
    zIndex: -1
  })))];
};
var _default = exports["default"] = genPickerMultipleStyle;